import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Payment, PrivilegeType } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { SalarySlipComponent } from '../salary-slip/salary-slip.component';

@Component({
  selector: 'app-renumaration',
  templateUrl: './renumaration.component.html',
  styleUrls: ['./renumaration.component.scss']
})
export class RenumarationComponent implements OnInit {
  public payments: Payment[] = [];
  public context: Context;
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  public fromDate: string;
  public toDate: string;
  public sid: number;
  private subscription: any;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private employeeService: EmployeeService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private datePipe: DatePipe

  ) { }

  ngOnInit(): void {
    this.fromDate = this.datePipe.transform(this.commonService.adjustDateByDays(-30), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd')
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.route.queryParams.subscribe(params => {
      if (params) {
        this.sid = params['sid'] || this.sid;
      }
    });
    this.subscription = this.authService.getContext().subscribe(context => {
      if (context?.employeeId) {
        this.context = context;
        this.getPayments();
      }
    });
  }

  private getPayments(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.payments = [];
      }
      if (!this.fromDate || !this.toDate) {
        this.commonService.setToastr(500, "Both \"From Date\" and \"To Date\" are required to proceed.")
        return;
      }
      const fromDate = this.datePipe.transform(this.fromDate, 'dd-MM-yyyy');
      const toDate = this.datePipe.transform(this.toDate, 'dd-MM-yyyy');
      this.employeeService.getPayments(this.context.employeeId, null, fromDate, toDate, 'DONE').subscribe({
        next: (payments: Payment[]) => {
          this.payments = payments.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  public processPayment(payment?: Payment) {
    let modalRef = this.modalService.open(SalarySlipComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.paymentId = payment.id;
    modalRef.componentInstance.salaryDate = payment.salaryDate;
    modalRef.result.then((response: Payment) => {

    })
      .catch((error) => {
      });
  }

  public onPaymentChange() {
    this.getPayments(false);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
